var _path, _g, _path2, _path3, _path4, _g2, _path5, _g3, _path6, _g4, _path7, _g5, _path8, _g6, _path9, _g7, _path0, _g8, _path1, _g9, _path10, _g0, _path11, _g1, _path12, _g10, _path13, _g11, _path14, _g12, _path15, _g13, _path16, _g14, _path17, _g15, _path18, _g16, _path19, _g17, _path20, _g18, _path21, _g19, _path22, _path23, _g20, _path24, _g21, _path25, _g22, _path26, _g23, _path27, _g24, _path28, _g25, _path29, _g26, _path30, _g27, _path31, _g28, _path32, _g29, _path33, _g30, _path34, _g31, _path35, _g32, _path36, _g33, _path37, _g34, _path38, _g35, _path39, _g36, _path40, _g37, _path41, _path42, _path43, _path44;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1453,
    height: 517,
    viewBox: "0 0 1453 517",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 364,
    y: 72,
    width: 74,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.3 81.4448C364.3 81.4448 366.397 82.6783 369.684 84.7663L381.81 93.0445C386.356 96.3511 391.013 99.8893 395.245 102.847C398.779 105.666 402.749 107.893 406.997 109.439C408.643 109.899 410.322 110.226 412.02 110.416C413.488 110.703 414.979 110.865 416.475 110.9C417.882 110.955 419.224 110.827 420.506 110.764C421.788 110.702 423.027 110.662 424.213 110.573C426.224 110.063 428.322 109.991 430.364 110.359C432.406 110.728 434.346 111.53 436.052 112.711C439.019 115.446 437.399 106.584 431.354 95.8811C429.715 93.1831 427.906 90.5931 425.935 88.1276C424.899 86.8433 423.818 85.5503 422.667 84.3762C421.517 83.202 420.309 82.1182 419.065 81.066C416.699 78.9911 414.092 77.2079 411.301 75.755C408.854 74.5365 406.233 73.7039 403.531 73.2864C401.07 72.9777 398.587 72.8782 396.109 72.9891C393.684 73.0054 391.261 73.1586 388.852 73.4482C384.541 74.0634 380.289 75.0377 376.14 76.3608C372.512 77.6343 369.534 78.8472 367.476 79.7327C365.436 80.7697 364.3 81.4448 364.3 81.4448Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.553 80.6924L366.662 65.1631L359.656 101.205L439.548 116.734L446.553 80.6924Z",
    fill: "#041133"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1326.85 425.847C1328.79 415.74 1334.65 406.814 1343.17 401.029C1351.68 395.243 1362.13 393.069 1372.25 394.985L1375.51 378.192C1360.96 375.435 1345.91 378.563 1333.66 386.89C1321.41 395.216 1312.97 408.061 1310.18 422.606C1307.31 437.137 1310.33 452.209 1318.57 464.517C1326.81 476.824 1339.59 485.361 1354.12 488.254L1357.38 471.468C1347.29 469.455 1338.41 463.522 1332.68 454.969C1326.96 446.417 1324.86 435.944 1326.85 425.847Z",
    fill: "#041133"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9464 91.0143C48.8841 80.9071 54.7521 71.9814 63.2629 66.1955C71.7737 60.4096 82.2322 58.2363 92.3435 60.1522L95.6064 43.366C81.0565 40.6079 66.0065 43.7348 53.7593 52.0604C41.5122 60.3861 33.0682 73.2304 30.2805 87.7747C27.4168 102.304 30.4343 117.377 38.6709 129.684C46.9074 141.991 59.6902 150.528 74.2139 153.421L77.4797 136.62C67.3905 134.607 58.5109 128.677 52.7874 120.128C47.0638 111.579 44.9633 101.109 46.9464 91.0143Z",
    fill: "#041133"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 80,
    width: 71,
    height: 42
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.1051 81.0447C94.5255 86.9049 98.2856 92.5602 102.366 97.9816C108.158 106.933 116.289 114.128 125.878 118.788C142.319 123.986 151.552 116.245 159.499 120.851C163.456 123.14 159.285 114.577 151.926 104.904C144.566 95.2307 133.947 84.5731 125.528 82.6328C114.209 80.2854 102.588 79.7545 91.1021 81.0598",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.692 89.9493L91.5664 74.5688L84.009 113.448L163.134 128.829L170.692 89.9493Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 163,
    y: 84,
    width: 69,
    height: 44
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.294 84.5768C166.565 90.5535 170.162 96.3453 174.07 101.926C179.579 111.081 187.451 118.585 196.858 123.651C213.063 129.504 222.613 122.136 230.344 127.129C234.178 129.612 230.439 120.829 223.496 110.778C216.553 100.726 206.301 89.5785 197.899 87.3532C186.592 84.5524 174.903 83.6148 163.294 84.5768Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.938 93.7649L163.668 78.5508L155.775 119.157L234.045 134.371L241.938 93.7649Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 235,
    y: 91,
    width: 67,
    height: 47
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.569 91.724C238.562 97.784 241.861 103.688 245.453 109.414C250.459 118.725 257.837 126.548 266.84 132.09C282.466 138.758 292.315 132.056 299.619 137.488C303.238 140.193 300.136 131.262 293.882 120.869C287.629 110.632 278.088 98.875 269.846 96.2288C258.751 92.8409 247.163 91.3176 235.569 91.724Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.592 101.251L235.785 86.5156L227.552 128.871L303.359 143.606L311.592 101.251Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 308,
    y: 102,
    width: 63,
    height: 52
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.026 102.006C308.026 102.006 308.897 104.177 310.439 107.546C311.981 110.916 314.176 115.456 316.8 120.313C321.183 129.945 327.99 138.275 336.557 144.488C342.518 147.472 349.08 149.061 355.746 149.137C360.345 148.648 364.967 149.823 368.775 152.448C372.135 155.439 369.836 146.266 364.414 135.404C359.01 124.685 350.305 112.195 342.197 108.936C334.759 105.97 326.977 103.952 319.034 102.93C315.386 102.397 311.709 102.093 308.023 102.02",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.018 113.809L307.711 99.5596L299.443 142.095L372.75 156.345L381.018 113.809Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 379,
    y: 117,
    width: 58,
    height: 58
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.387 117.987C379.387 117.987 380.081 120.226 381.336 123.71C382.591 127.195 384.42 131.89 386.594 136.98C390.103 146.94 396.092 155.843 403.996 162.846C409.608 166.368 415.941 168.582 422.526 169.323C427.13 169.279 431.592 170.914 435.079 173.921C438.068 177.26 436.813 167.885 432.556 156.517C428.293 145.303 420.816 131.984 412.989 127.962C405.818 124.296 398.206 121.564 390.34 119.835C386.731 118.992 383.072 118.375 379.387 117.987Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.03 130.052L378.852 116.605L369.498 164.726L438.676 178.173L448.03 130.052Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 449,
    y: 141,
    width: 52,
    height: 64
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.266 141.531C449.266 141.531 449.731 143.826 450.613 147.426C451.495 151.025 452.823 155.857 454.438 161.172C456.848 171.426 461.778 180.916 468.782 188.782C473.928 192.908 479.924 195.843 486.34 197.376C490.901 197.889 495.115 200.061 498.18 203.479C500.713 207.158 500.691 197.735 497.897 185.934C495.043 174.324 489.179 160.165 481.803 155.265C475.047 150.765 467.731 147.169 460.042 144.569C456.518 143.327 452.919 142.312 449.266 141.531Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512.041 152.931L448.65 140.609L437.934 195.742L501.324 208.064L512.041 152.931Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 516,
    y: 172,
    width: 44,
    height: 70
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.826 172.881C516.826 172.881 516.989 175.25 517.408 178.907C517.826 182.564 518.503 187.542 519.393 193.02C520.406 203.463 523.963 213.498 529.754 222.247C534.224 227.014 539.691 230.736 545.763 233.15C550.176 234.279 554.005 237.022 556.493 240.838C558.437 244.823 559.816 235.524 558.769 223.439C557.638 211.58 553.838 196.701 547.193 190.805C541.13 185.413 534.368 180.862 527.089 177.275C524.689 176.043 522.225 174.937 519.709 173.963L516.807 172.861",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M571.306 182.683L516.211 171.973L503.959 235.003L559.054 245.713L571.306 182.683Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 579,
    y: 212,
    width: 36,
    height: 76
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M579.568 212.804C579.568 212.804 579.398 215.162 579.274 218.886C579.15 222.609 579.127 227.661 579.2 233.214C578.627 243.8 580.764 254.356 585.408 263.886C595.143 277.932 607.222 277.592 610.854 286.12C612.685 290.371 614.416 280.946 614.45 268.783C614.485 256.621 612.705 241.69 607.093 234.928C601.851 228.761 595.827 223.303 589.175 218.691C586.098 216.531 582.89 214.565 579.568 212.804Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M626.928 221.213L578.957 211.888L565.331 281.99L613.301 291.315L626.928 221.213Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 634,
    y: 260,
    width: 38,
    height: 74
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M636.098 260.22C635.041 266.894 634.436 273.633 634.288 280.389C633.273 291.145 635.545 301.956 640.805 311.393C645.164 317.014 650.876 321.437 657.409 324.25C662.111 325.772 666.268 328.63 669.374 332.474C672.044 336.576 671.903 326.842 670.637 314.715C669.253 302.596 666.906 288.178 661.574 281.899C656.556 276.15 650.953 270.941 644.854 266.355C639.825 262.487 636.098 260.22 636.098 260.22Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M685.953 269.123L635.482 259.312L622.193 327.68L672.664 337.491L685.953 269.123Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 690,
    y: 302,
    width: 52,
    height: 63
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M690.446 302.511C690.446 302.511 690.302 304.82 690.341 308.466C690.421 313.176 690.809 317.876 691.501 322.536C692.482 333.531 697.248 343.845 704.987 351.716C708.266 354.243 711.927 356.233 715.831 357.611C718.952 358.717 722.184 359.481 725.47 359.889C728.407 360.367 731.079 360.652 733.519 361.166C735.895 361.655 738.138 362.652 740.095 364.088C744.224 367.095 740.414 357.917 735.314 346.798C730.072 335.651 724.284 322.621 718.048 317.989C712.166 313.814 705.974 310.092 699.528 306.855C696.894 305.455 694.607 304.395 692.989 303.66L690.443 302.487",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M755.287 314.288L689.832 301.565L679.397 355.249L744.852 367.972L755.287 314.288Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 750,
    y: 329,
    width: 74,
    height: 42
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M750.102 329.767C751.9 336.188 754.498 342.357 757.837 348.13C759.263 350.587 760.853 352.944 762.597 355.186C764.345 357.53 766.319 359.696 768.492 361.653C770.567 363.582 772.851 365.273 775.303 366.693C777.576 367.96 780.015 368.901 782.55 369.489C784.823 369.895 787.124 370.118 789.432 370.157C791.481 370.236 793.533 370.095 795.552 369.734C797.466 369.428 799.258 369.028 800.932 368.59C802.559 368.11 804.161 367.548 805.731 366.905L813.878 363.674C816.291 362.758 818.864 362.333 821.444 362.426C824.09 362.48 823.314 361.099 820.5 359.025C817.685 356.95 812.827 353.77 807.773 350.552L792.444 339.953C790.036 338.394 787.734 336.848 785.596 335.661C783.734 334.618 781.744 333.82 779.677 333.287C772.46 331.939 765.235 331.072 759.62 330.542C754.004 330.011 750.102 329.767 750.102 329.767Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M828.853 342.05L749.9 326.704L742.928 362.573L821.881 377.92L828.853 342.05Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 809,
    y: 306,
    width: 77,
    height: 38
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M809.851 327.954C809.851 327.954 811.461 329.451 814.33 331.606C818.063 334.397 822.104 336.751 826.374 338.621C828.959 339.799 831.643 340.743 834.396 341.442C837.244 342.236 840.165 342.746 843.114 342.966C845.994 343.151 848.886 343.045 851.745 342.649C854.358 342.181 856.886 341.329 859.249 340.119C861.374 339.031 863.365 337.7 865.185 336.154C866.849 334.853 868.39 333.403 869.79 331.822C872.131 329.07 874.16 326.068 875.838 322.869C877.304 319.936 878.658 317.418 879.946 315.043C881.134 312.678 882.819 310.598 884.886 308.945C886.963 307.159 885.432 306.659 881.926 307.061C878.274 307.332 872.724 308.388 866.644 309.209L857.295 310.329C854.121 310.623 850.963 310.843 848.17 311.18C843.424 311.342 838.736 312.273 834.289 313.936C831.209 315.674 828.003 317.178 825.269 318.937C822.333 320.415 819.833 322.212 817.48 323.414C815.202 324.755 813.32 325.979 811.935 326.692C810.55 327.404 809.808 327.976 809.808 327.976",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M887.955 306.371L815.977 292.38L807.265 337.198L879.244 351.189L887.955 306.371Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 854,
    y: 221,
    width: 44,
    height: 70
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M854.319 290.736C856.208 290.776 858.099 290.711 859.981 290.543C862.063 290.363 864.134 290.077 866.186 289.684C868.647 289.144 871.071 288.444 873.441 287.589C874.737 287.124 876.054 286.601 877.392 286.02C878.65 285.399 879.893 284.698 881.155 283.938C883.738 282.408 886.142 280.594 888.322 278.53C890.418 276.415 892.278 274.078 893.868 271.561C895.247 269.106 896.231 266.45 896.785 263.69C897.304 261.198 897.477 258.647 897.3 256.108C897.213 253.862 896.991 251.623 896.632 249.403C895.637 245.733 894.328 242.155 892.72 238.709C889.486 233.945 887.116 228.647 885.72 223.06C885.334 220.313 884.117 221.323 882.522 224.519C881.715 226.107 880.799 228.212 879.785 230.586C878.77 232.959 877.368 235.764 876.064 238.502C873.401 243.963 870.454 249.28 867.234 254.432C864.536 257.993 862.338 261.907 860.704 266.064C860.505 266.844 860.342 267.607 860.209 268.368C860.077 269.129 859.767 269.84 859.591 270.585C859.142 272.056 859.018 273.535 858.589 274.94C857.733 277.742 857.302 280.439 856.513 282.732C856.178 283.898 856 284.97 855.698 285.963C855.396 286.956 855.108 287.757 854.908 288.466C854.494 289.874 854.312 290.688 854.312 290.688",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M905.541 223.443L868.035 216.153L853.414 291.375L890.919 298.665L905.541 223.443Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 818,
    y: 170,
    width: 44,
    height: 70
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M852.963 239.055C854.058 237.491 855.063 235.865 855.974 234.187C858.016 230.087 859.587 225.769 860.657 221.315C861.257 218.565 861.621 215.769 861.745 212.957C861.955 210.012 861.833 207.053 861.379 204.137C860.923 201.301 860.182 198.518 859.168 195.83C858.187 193.377 856.801 191.106 855.067 189.112C849.864 183.132 842.978 178.861 835.308 176.857C832.387 175.853 829.639 175.28 827.206 174.449C824.835 173.672 822.657 172.396 820.821 170.707C818.896 169.024 818.606 170.557 819.419 173.909C820.232 177.261 821.896 182.727 823.793 188.401L829.39 206.021C830.142 208.564 831.064 211.055 832.148 213.475C832.832 215.445 833.838 217.289 835.123 218.931L836.879 220.877C837.408 221.564 837.949 222.23 838.494 222.874C839.576 224.159 840.716 225.347 841.838 226.469C842.808 227.693 843.795 228.828 844.777 229.868C845.738 230.802 846.644 231.792 847.488 232.833C849.027 234.737 850.555 236.211 851.52 237.302C852.484 238.393 852.953 239.069 852.953 239.069",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M869.956 178.099L818.307 168.059L806.129 230.706L857.779 240.746L869.956 178.099Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 738,
    y: 160,
    width: 70,
    height: 44
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M807.086 203.647C807.086 203.647 806.733 201.452 805.907 197.965C805.468 196.22 804.895 194.153 804.141 191.864C803.289 189.466 802.311 187.114 801.209 184.82C799.975 182.239 798.58 179.737 797.032 177.331C795.38 174.94 793.548 172.678 791.554 170.564C790.546 169.495 789.499 168.484 788.412 167.53C787.332 166.665 786.203 165.863 785.03 165.127C782.81 163.708 780.402 162.605 777.876 161.851C773.593 160.881 769.186 160.573 764.809 160.94C761.471 161.356 758.177 162.071 754.967 163.078C750.284 165.271 745.114 166.217 739.957 165.824C737.488 165.344 738.04 166.791 740.467 169.297C742.894 171.802 747.098 175.26 751.783 179.217C754.145 181.172 756.626 183.119 759.105 185.073C761.585 187.028 764.069 189.038 766.449 190.739C768.83 192.44 770.997 194.194 773.038 195.401C774.81 196.509 776.708 197.401 778.692 198.058C780.407 198.56 782.147 198.971 783.906 199.29C785.625 199.624 787.309 200.138 788.95 200.434L798.009 202.124C800.723 202.473 802.941 203.005 804.55 203.263C806.159 203.522 807.087 203.64 807.087 203.64",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M814.773 168.173L738.98 153.44L731.845 190.15L807.637 204.883L814.773 168.173Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 667,
    y: 178,
    width: 80,
    height: 34
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M746.521 201.481C746.521 201.481 745.014 199.731 742.391 197.235C738.949 194.013 735.28 191.043 731.412 188.346C722.661 181.594 711.835 178.093 700.787 178.443C693.598 179.647 686.847 182.703 681.199 187.311C676.581 190.745 673.211 193.814 668.409 194.073C663.606 194.331 672.108 199.092 683.533 203.518C694.959 207.944 708.882 212.388 716.664 210.994C720.453 210.228 724.198 209.26 727.885 208.096C731.404 207.144 734.607 205.936 737.358 204.974C740.108 204.013 742.39 203.132 744 202.464L746.521 201.481Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M750.721 183.935L667.992 167.854L660.991 203.873L743.72 219.954L750.721 183.935Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 605,
    y: 212,
    width: 80,
    height: 33
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M684.7 226.174C684.7 226.174 682.721 225.01 679.45 223.322C675.25 221.154 670.923 219.241 666.493 217.594C656.7 213.147 645.802 211.726 635.196 213.513C618.457 218.907 615.503 230.658 606.385 231.511C601.846 231.898 610.177 236.572 621.742 240.121C633.307 243.67 648.075 246.252 655.936 243.168C663.039 240.248 669.825 236.607 676.185 232.302C678.787 230.54 680.919 229.03 682.401 227.939C683.883 226.849 684.7 226.174 684.7 226.174Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M686.975 218.476L606.686 202.87L599.861 237.981L680.15 253.587L686.975 218.476Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 543,
    y: 250,
    width: 81,
    height: 33
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M623.587 263.454C617.501 260.521 611.266 257.905 604.909 255.616C595.264 251.382 584.696 249.69 574.211 250.7C557.971 254.766 554.133 265.815 545.161 265.598C540.729 265.352 548.281 271.152 559.366 275.768C570.471 280.56 585.235 283.968 593.542 281.071C601.069 278.326 608.215 274.63 614.806 270.075C617.865 268.048 620.797 265.837 623.587 263.454Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M625.766 256.314L544.756 240.567L537.953 275.565L618.963 291.312L625.766 256.314Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 480,
    y: 278,
    width: 79,
    height: 35
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M558.927 298.465C558.927 298.465 556.935 297.205 553.72 295.349C550.505 293.493 546.093 291.023 541.198 288.467C536.249 285.884 531.159 283.579 525.954 281.561C521.53 279.73 516.794 278.768 512.006 278.725C508.496 278.971 505.028 279.633 501.674 280.698C499.053 281.638 496.495 282.746 494.017 284.017C489.484 286.096 485.823 288.259 481.674 286.876C479.625 286.236 480.05 287.737 482.147 290.334C483.502 291.957 484.964 293.488 486.523 294.916C488.576 296.746 490.726 298.464 492.963 300.063C495.521 301.914 498.176 303.627 500.917 305.193C503.72 306.725 506.621 308.07 509.601 309.218C514.669 311.473 520.231 312.391 525.755 311.883C533.875 310.396 541.737 307.744 549.1 304.01C551.557 302.826 553.95 301.513 556.269 300.075L558.931 298.403",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M562.035 286.698L481.799 271.102L475.283 304.621L555.52 320.217L562.035 286.698Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 415,
    y: 286,
    width: 72,
    height: 41
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M486.231 322.146L481.847 317.85L471.37 307.937C467.317 304.22 462.95 300.395 458.69 297.019C456.714 295.464 454.626 294.058 452.442 292.813C450.651 291.643 448.71 290.72 446.672 290.071C444.953 289.579 443.195 289.237 441.417 289.049C439.893 288.754 438.349 288.576 436.799 288.518C433.885 288.357 431.272 288.893 428.841 288.934C424.046 289.194 419.942 289.908 416.758 286.967C415.183 285.571 414.967 287.126 415.844 290.35C416.429 292.387 417.158 294.38 418.027 296.314C419.178 298.803 420.489 301.216 421.952 303.535C423.633 306.23 425.47 308.824 427.454 311.305C429.531 313.787 431.808 316.095 434.261 318.206C436.545 320.29 439.073 322.09 441.789 323.565C444.125 324.799 446.638 325.663 449.238 326.127C457.758 327.259 466.408 326.946 474.824 325.203C477.619 324.731 480.377 324.059 483.075 323.192L486.161 322.187",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.737 297.865L414.969 282.942L407.973 318.932L484.741 333.854L491.737 297.865Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 356,
    y: 260,
    width: 52,
    height: 63
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407.803 322.207L405.397 316.512C404.645 314.808 403.785 312.778 402.792 310.552C401.799 308.325 400.793 305.808 399.714 303.222C397.541 298.125 395.151 292.947 392.795 288.072C391.695 285.84 390.436 283.69 389.029 281.637C387.876 279.838 386.514 278.182 384.971 276.704C383.634 275.528 382.201 274.468 380.687 273.533C379.3 272.649 378.052 271.775 376.754 271.117C374.382 269.977 371.942 268.983 369.449 268.139C367.412 267.367 365.428 266.461 363.51 265.427C362.666 264.955 361.891 264.37 361.207 263.686C360.572 262.935 360.066 262.084 359.71 261.167C358.977 259.248 358.081 260.531 357.387 263.777C356.98 265.846 356.727 267.943 356.628 270.049C356.573 272.774 356.688 275.5 356.974 278.211C357.295 281.375 357.816 284.516 358.535 287.614C359.38 290.737 360.453 293.794 361.743 296.761C363.802 302.129 367.314 306.818 371.888 310.302C379.243 315.048 387.378 318.46 395.919 320.38C398.726 321.132 401.592 321.648 404.485 321.921L407.796 322.245",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_21_385)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask22_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 348,
    y: 260,
    width: 70,
    height: 63
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M417.639 271.625L358.107 260.053L348.167 311.192L407.699 322.763L417.639 271.625Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.555 271.007L357.492 259.137L347.256 311.8L408.319 323.669L418.555 271.007Z",
    fill: "#041133"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 307,
    y: 211,
    width: 32,
    height: 78
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.99 288.227C335.99 288.227 336.13 285.824 336.357 282.011C336.455 280.145 336.581 277.934 336.713 275.49C336.845 273.046 337.149 270.323 337.382 267.517C337.803 262.146 338.254 256.382 338.668 251.002C338.84 248.592 338.85 246.173 338.697 243.762C338.757 241.703 338.519 239.647 337.99 237.657C337.501 235.886 336.765 234.419 336.228 232.975C335.745 231.623 335.144 230.318 334.431 229.073C333.787 227.957 333.069 226.885 332.281 225.866C331.538 224.88 331.018 223.867 330.361 222.96C329.159 221.295 328.071 219.551 327.106 217.739C326.388 216.021 326.294 214.107 326.841 212.327C327.421 210.469 325.931 210.919 323.415 213.001C321.839 214.357 320.374 215.836 319.034 217.424C318.235 218.367 317.365 219.437 316.564 220.551C315.763 221.665 315.074 222.848 314.311 224.125C310.992 229.68 308.769 235.821 307.764 242.213C307.245 245.351 307.088 248.539 307.297 251.713C307.593 254.427 308.304 257.08 309.406 259.578C313.432 267.749 319.086 275.01 326.022 280.914C327.411 282.142 328.673 283.307 329.879 284.196L333.1 286.38L335.963 288.207",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.151 214.285L313.367 206.94L298.817 281.794L336.601 289.139L351.151 214.285Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 287,
    y: 152,
    width: 49,
    height: 67
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.575 218.606L295.584 213.815C297.968 210.928 301.781 206.94 305.474 203.015C307.263 201.025 309.488 199.035 311.456 197.088C313.424 195.141 315.263 193.255 317.23 191.432C318.997 189.781 320.66 188.023 322.211 186.168C323.555 184.666 324.718 183.012 325.677 181.24C327.057 178.459 328.094 175.522 328.765 172.491C329.324 170.074 329.702 167.619 329.896 165.146C330.084 163.074 330.482 161.027 331.084 159.036C331.593 157.201 332.791 155.633 334.428 154.66C336.122 153.603 334.687 152.966 331.384 152.885C329.27 152.866 327.157 153.012 325.066 153.324C322.366 153.771 319.702 154.415 317.096 155.249C310.885 157.178 305.075 160.214 299.944 164.209C297.506 166.221 295.278 168.474 293.292 170.933C291.62 173.129 290.347 175.604 289.534 178.242C289.176 179.443 288.809 180.649 288.525 181.871C288.241 183.094 288.099 184.344 287.929 185.581C287.604 188.05 287.261 190.499 287.185 192.892C287.079 197.305 287.395 201.718 288.129 206.071C288.594 209.177 289.323 212.238 290.309 215.22C291.07 217.355 291.557 218.579 291.557 218.579",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.117 152.693L295.01 144.508L280.858 217.312L322.966 225.497L337.117 152.693Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 302,
    y: 100,
    width: 76,
    height: 37
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.855 136.799L309.058 135.87C312.913 135.357 318.216 134.768 323.634 134.154L340.242 132.637C342.67 132.442 345.081 132.086 347.461 131.571C349.488 131.279 351.463 130.7 353.327 129.852C354.92 128.993 356.39 128.243 357.73 127.482C358.961 126.742 360.123 125.891 361.2 124.939C363.159 123.471 364.97 121.817 366.609 119.999C369.878 117.09 372.604 114.286 376.548 115.037C378.444 115.343 377.793 113.923 375.383 111.694C371.731 108.524 367.55 106.023 363.029 104.306C356.959 101.853 350.483 100.557 343.936 100.486C337.961 100.313 332.062 101.872 326.952 104.976C322.919 107.819 319.225 111.116 315.943 114.802C313.145 118.097 310.612 121.609 308.37 125.305C306.502 128.619 304.994 131.411 304.12 133.461L302.866 136.747",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.077 105.79L310.734 92.1172L301.922 137.453L372.264 151.126L381.077 105.79Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 445,
    y: 77,
    width: 52,
    height: 64
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.833 77.6822C445.833 77.6822 446.7 79.9542 448.062 83.569C449.424 87.1837 451.309 91.8741 453.347 97.0616C455.385 102.249 457.539 107.56 459.829 112.532C460.887 114.819 462.115 117.024 463.502 119.128C464.625 121.01 466.01 122.722 467.617 124.213C472.331 128.317 477.849 131.393 483.819 133.244C488.159 134.05 492.016 136.509 494.577 140.103C496.542 143.905 497.855 134.742 496.206 122.665C494.558 110.822 489.171 95.9305 481.281 90.7117C474.089 85.8436 466.134 82.2117 457.745 79.9664C453.828 78.9487 449.852 78.1758 445.839 77.652",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M508.05 88.8018L445.26 76.5967L434.367 132.638L497.156 144.843L508.05 88.8018Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 516,
    y: 110,
    width: 36,
    height: 76
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.178 110.975L516.124 117.143C516.11 120.942 516.257 125.957 516.443 131.532C515.948 141.995 517.923 152.428 522.21 161.986C531.319 175.964 543.24 176.201 546.295 184.812C547.791 189.139 550.257 179.942 550.961 167.863C551.665 155.783 550.318 140.672 544.622 133.699C539.334 127.256 533.141 121.612 526.237 116.943C523.011 114.751 519.654 112.758 516.185 110.977",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M562.839 119.249L515.566 110.06L501.781 180.98L549.054 190.169L562.839 119.249Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 568,
    y: 160,
    width: 35,
    height: 78
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M572.315 160.698C570.895 167.332 569.851 174.04 569.188 180.791C567.355 191.374 568.609 202.261 572.8 212.15C582.103 227.335 594.68 227.442 598.393 236.157C600.393 240.535 601.811 230.955 602.083 218.777C602.355 206.598 601.447 191.868 596.602 184.928C592.02 178.583 586.739 172.774 580.858 167.61C578.141 165.159 575.297 162.854 572.337 160.703",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M615.207 168.24L571.402 159.725L557.175 232.92L600.979 241.435L615.207 168.24Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 621,
    y: 210,
    width: 43,
    height: 71
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M623.586 210.268C623.586 210.268 623.148 212.52 622.706 216.158C622.121 220.834 621.833 225.543 621.843 230.255C621.099 241.194 624.057 252.065 630.241 261.119C633.021 264.06 636.2 266.597 639.683 268.657C642.446 270.322 645.396 271.654 648.471 272.624C653.381 273.619 657.887 276.046 661.42 279.598C664.59 283.33 663.293 273.729 660.696 261.756C659.373 255.781 657.63 249.474 655.784 243.662C654.431 238.757 652.068 234.19 648.847 230.253C646.079 227.378 643.097 224.804 640.255 222.35C637.413 219.897 634.573 217.834 632.13 216.05C629.688 214.266 627.523 212.817 626.012 211.814L623.584 210.275",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M677.728 220.004L623.008 209.368L610.523 273.599L665.242 284.235L677.728 220.004Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 678,
    y: 247,
    width: 57,
    height: 60
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M678.877 247.946C679.374 254.644 680.478 261.284 682.173 267.783C685.05 278.19 690.509 290.509 698.31 295.344C704.379 299.265 711.364 301.539 718.578 301.94C723.5 301.741 728.372 302.994 732.586 305.544C736.376 308.571 733.187 299.248 727.769 288.441C722.31 277.408 715.164 264.792 708.339 260.583C706.6 259.552 704.815 258.675 703.06 257.765C701.304 256.855 699.602 255.955 697.901 255.204C694.529 253.598 691.181 252.503 688.427 251.321C685.306 250.03 682.116 248.913 678.871 247.976",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M746.549 260.305L678.264 247.031L668.706 296.203L736.991 309.476L746.549 260.305Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 742,
    y: 270,
    width: 66,
    height: 49
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M742.543 270.816C742.543 270.816 743.2 273.047 744.477 276.537C746.161 280.97 748.106 285.299 750.301 289.503C754.665 299.512 762.069 307.894 771.463 313.459C788.265 320.247 798.284 312.752 806.342 317.629C810.427 319.982 806.104 311.397 799.075 301.305C791.98 291.356 782.539 279.884 774.776 277.175C770.992 275.798 767.112 274.7 763.168 273.89C759.424 273.108 755.923 272.365 752.847 271.954C746.711 271.136 742.543 270.816 742.543 270.816Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M818.268 283.698L742.115 268.895L734.028 310.5L810.181 325.302L818.268 283.698Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 811,
    y: 280,
    width: 71,
    height: 42
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M811.038 281.102C814.086 287.155 817.568 292.979 821.455 298.53C827.062 307.739 835.268 315.084 845.041 319.639C862.042 324.72 871.215 316.53 879.472 320.784C883.626 322.901 878.893 314.502 871.138 305.141C863.382 295.78 852.711 285.308 844.528 283.359C837.01 281.718 829.339 280.877 821.643 280.85C818.112 280.756 814.578 280.849 811.056 281.129",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M890.54 291.252L811.271 275.844L803.816 314.198L883.084 329.606L890.54 291.252Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 881,
    y: 283,
    width: 72,
    height: 40
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M881.64 284.649C885.124 290.429 888.992 295.967 893.22 301.227C899.296 310.013 907.714 316.918 917.518 321.158C934.304 325.66 943.146 317.57 951.363 321.746C959.581 325.922 932.645 288.502 915.735 285.278C904.47 283.372 892.983 283.161 881.655 284.652",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M966.545 294.303L882.164 277.901L874.969 314.919L959.349 331.321L966.545 294.303Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 953,
    y: 285,
    width: 71,
    height: 42
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M953.379 286.407C956.905 292.212 960.759 297.812 964.921 303.18C970.837 312.025 979.016 319.122 988.607 323.732C1004.9 328.808 1014.04 321.142 1021.84 325.822C1025.68 328.25 1021.8 319.425 1014.5 309.78C1007.26 300.012 996.498 289.389 987.971 287.483C976.562 285.279 964.872 284.924 953.35 286.433",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1032.95 294.982L953.904 279.616L946.398 318.233L1025.45 333.598L1032.95 294.982Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1026,
    y: 289,
    width: 67,
    height: 47
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1026.41 289.654C1029.61 295.631 1033.1 301.443 1036.88 307.067C1042.07 316.249 1049.48 323.979 1058.44 329.543C1064.49 332.047 1071.03 333.159 1077.57 332.795C1082.05 331.996 1086.66 332.893 1090.51 335.309C1093.91 338.112 1091.35 329.116 1085.4 318.477C1079.45 308.073 1069.77 296.149 1061.32 293.54C1057.23 292.191 1053.02 291.215 1048.76 290.623C1045.03 290.054 1041.28 289.679 1037.52 289.499C1033.82 289.369 1030.11 289.428 1026.41 289.676",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1102.11 300.018L1026.47 285.314L1018.88 324.344L1094.52 339.048L1102.11 300.018Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1100,
    y: 300,
    width: 58,
    height: 57
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1100.36 300.456C1100.36 300.456 1103.72 309.142 1108.41 319.161C1110.79 324.213 1113.48 329.115 1116.46 333.838C1118.84 338.042 1122.11 341.68 1126.03 344.503C1131.43 348.046 1137.57 350.293 1143.98 351.068C1148.49 351.178 1152.81 352.943 1156.11 356.028C1158.89 359.444 1158.18 350.12 1154.35 338.671C1152.37 332.645 1149.66 326.884 1146.27 321.519C1143.56 316.702 1139.66 312.657 1134.95 309.767C1131.01 307.809 1126.95 306.124 1122.78 304.722C1118.76 303.511 1114.91 302.623 1111.59 301.954C1108.91 301.379 1106.2 300.957 1103.47 300.688L1100.35 300.447",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1168.85 312.282L1099.87 298.873L1090.52 346.941L1159.51 360.35L1168.85 312.282Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1171,
    y: 323,
    width: 50,
    height: 67
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1171.82 323.962C1171.82 323.962 1173.31 333.359 1176.05 344.011C1177.88 354.465 1182.34 364.281 1189.01 372.536C1201.57 384.025 1213.27 381.086 1218.6 388.642C1223.92 396.198 1218.02 350.262 1203.79 339.486C1197.27 334.632 1190.14 330.646 1182.59 327.629C1179.08 326.224 1175.49 325.007 1171.85 323.983",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1236.39 335.726L1171.21 323.055L1159.27 384.479L1224.45 397.149L1236.39 335.726Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1237,
    y: 358,
    width: 48,
    height: 67
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1237.27 358.071C1237.66 364.804 1238.46 371.507 1239.65 378.144C1240.8 388.767 1244.96 398.841 1251.64 407.174C1264.61 419.144 1276.54 415.909 1282.33 423.266C1285.32 426.964 1284.3 417.417 1281.36 405.642C1278.42 393.868 1273.53 379.968 1266.98 374.652C1257.95 367.679 1247.94 362.091 1237.27 358.071Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1297.38 368.968L1236.66 357.164L1225.21 416.043L1285.94 427.847L1297.38 368.968Z",
    fill: "#041133"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_21_385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1299,
    y: 391,
    width: 56,
    height: 60
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1299.64 391.579C1300.26 398.238 1301.43 404.835 1303.12 411.304C1304.52 416.793 1306.49 422.12 1309.01 427.196C1311.2 431.847 1314.48 435.901 1318.57 439.02C1321.87 441.331 1325.52 443.093 1329.38 444.237C1332.46 445.166 1335.63 445.782 1338.83 446.074C1343.87 445.988 1348.83 447.322 1353.14 449.923C1355.12 451.384 1355.27 449.831 1354.18 446.588C1352.5 441.887 1350.52 437.301 1348.24 432.859C1342.85 421.886 1336.25 409.158 1329.49 404.851C1323.13 400.97 1316.44 397.674 1309.49 395.005C1303.74 392.765 1299.65 391.534 1299.65 391.534",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_21_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1365.24 403.541L1299.05 390.675L1289.56 439.471L1355.75 452.338L1365.24 403.541Z",
    fill: "#041133"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6016 43.3628L92.3387 60.149C102.431 62.1603 111.314 68.0932 117.038 76.646C122.761 85.1987 124.859 95.6727 122.869 105.77C120.929 115.876 115.061 124.8 106.551 130.586C98.0404 136.371 87.583 138.546 77.4719 136.632L74.209 153.418C88.7597 156.176 103.81 153.05 116.059 144.725C128.307 136.399 136.753 123.555 139.542 109.011C142.404 94.4802 139.385 79.4076 131.147 67.1003C122.909 54.7931 110.126 46.2562 95.6016 43.3628Z",
    fill: "#041133"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1375.48 378.188L1372.22 394.982C1382.31 396.995 1391.19 402.928 1396.91 411.48C1402.64 420.033 1404.74 430.505 1402.75 440.602C1400.81 450.709 1394.94 459.633 1386.43 465.419C1377.92 471.204 1367.46 473.378 1357.35 471.464L1354.09 488.251C1368.64 491.009 1383.69 487.882 1395.94 479.556C1408.18 471.231 1416.63 458.386 1419.41 443.842C1422.28 429.312 1419.26 414.239 1411.02 401.93C1402.79 389.622 1390.01 381.083 1375.48 378.188Z",
    fill: "#041133"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2507 116.546C96.4408 120.865 70.1015 83.1018 53.1146 79.5895C47.8892 78.5422 42.5835 77.9461 37.256 77.8079L33.2023 98.6627C38.6616 105.99 45.9726 111.732 54.3847 115.3C71.074 120.102 80.1205 112.2 88.2507 116.546Z",
    fill: "#041133"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1393.6 419.538C1386.81 417.923 1379.92 416.757 1372.97 416.049L1365.93 415.381L1363.19 415.223C1363.19 415.223 1363.82 417.401 1365.08 420.818C1366.7 425.248 1368.67 429.54 1370.98 433.651C1375.74 443.73 1384.09 451.661 1394.41 455.882C1398.48 456.97 1402.71 457.359 1406.91 457.034L1407.28 456.982L1412.16 431.893C1410.15 430.209 1408.14 428.54 1406.24 426.979C1402.55 423.702 1398.26 421.174 1393.6 419.538Z",
    fill: "#041133"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRope);
export default __webpack_public_path__ + "static/media/Rope.598a81b1591511a9c0ae6744170ef339.svg";
export { ForwardRef as ReactComponent };